<template>
<div class="chapter">
<div class="inner_page">
<div id="sec-4">
<p class="copy" id="pz4-6" style="margin-top: 3em; margin-bottom: 0.1em;">
<b>INTERGENERATE</b> </p>
<p class="copy" id="A5x">
<i>Transforming Churches through Intergenerational Ministry</i> </p>
<div class="image" id="ARR">
<img alt="images/himg-4-1.png" id="Ane0" src="images/himg-4-1.png"/></div>
<p class="copy" id="AO0" style="margin-top: 1em;">
					Copyright © 2018 by Holly Catterton Allen </p>
<p class="copy" id="A6Q">
					ISBN 978-1-68426-150-5 | LCCN 2018015666 </p>
<p class="copy" id="AVUA">
					Printed in the United States of America </p>
<p class="copy" id="A66T" style="margin-bottom: 0em;">
					ALL RIGHTS RESERVED </p>
<p class="copy" id="pz4-7">
					No part of this publication may be reproduced, stored in a retrieval system, or transmitted
					in any form by any means—electronic, mechanical, photocopying, recording, or otherwise—without
					prior written consent. </p>
<p class="copy" id="pz4-8">
					All Scripture quotations, unless otherwise indicated, are taken from the Holy Bible,
					New International Version<sup>®</sup>, NIV<sup>®</sup>. Copyright © 1973, 1978, 1984, 2011 by Biblica,
					Inc.™ Used by permission of Zondervan. All rights reserved worldwide. </p>
<p class="copy" id="pz4-9">
					Scripture quotations noted <span style="font-variant: small-caps;">nrsv</span> are taken from the New Revised Standard Version Bible,
					copyright © 1989, the Division of Christian Education of the National Council of
					the Churches of Christ in the United States of America. Used by permission. All rights
					reserved. </p>
<p class="copy" id="pz4-10">
					INTERGENERATE ™ is a registered trademark of Lipscomb University, used under permission
					of Lipscomb University. All rights reserved. </p>
<p class="copy" id="pz4-11">
					Photographs on pages 242–43 are in the public domain and have been provided by Vibrant
					Faith from the Visual Faith Project. </p>
<p class="copy" id="pz4-12">
					Parts of Chapter Two are drawn from a previous publication: Gareth Crispin. “A Theology
					of Accommodation as a Resource for Integrating Youth and Children into Intergenerational
					Church” from <i>Christian Education Journal</i>. Copyright © 2017 by <i>Christian Education
					Journal</i>. Reprinted by permission of <i>Christian Education Journal</i>. </p>
<p class="copy" id="pz4-13" style="padding-bottom: 1em; margin-bottom: 0.4em; border-bottom: solid 1px #000000;">
					Parts of Chapter Fourteen are drawn from a previous publication: Holly C. Allen.
					"Walking with Emerging Adults on the Spiritual Journey" from <i>A Faith for the Generations</i>.
					Copyright © 2015 by Timothy W. Herrmann, Kirsten D. TenHaken, Hannah M. Adderley,
					and Morgan K. Morris. Reprinted by permission of Abilene Christian University Press.
					</p>
<p class="copy" id="AHq" style="margin-bottom: 0em;">
					LIBRARY OF CONGRESS CATALOGING-IN-PUBLICATION DATA </p>
<p class="copy" id="APz" style="margin-bottom: 0em;">
					Names: Allen, Holly Catterton, editor. </p>
<p class="copy" id="ASJ" style="margin-bottom: 0em;">
					Title: Intergenerate : transforming churches through intergenerational ministry /
					edited by Holly Catterton Allen. </p>
<p class="copy" id="A72" style="margin-bottom: 0em;">
					Description: Abilene : Abilene Christian University Press, 2018. </p>
<p class="copy" id="AGI" style="margin-bottom: 0em;">
					Identifiers: LCCN 2018015666 | ISBN 9781684261505 (pbk.) </p>
<p class="copy" id="ADB" style="margin-bottom: 0em;">
					Subjects: LCSH: Church. | Intergenerational relations—Religious aspects—Christianity.
					</p>
<p class="copy" id="AlR" style="margin-bottom: 0em;">
					Classification: LCC BV640 .I58 2018 | DDC 253—dc23 </p>
<p class="copy" id="AY5z" style="padding-bottom: 0.2em; margin-bottom: 1.5em; border-bottom: solid 1px #000000;">
					LC record available at <a href="https://lccn.loc.gov/" id="A4mR" target="_blank">https://lccn.loc.gov/</a> 2018015666 </p>
<p class="copy" id="pz4-15">
					Cover design by ThinkPen Design | Interior text design by Sandy Armstrong, Strong
					Design </p>
<p class="copy" id="pz4-16" style="margin-bottom: 0em;">
					For information contact: </p>
<p class="copy" id="pz4-17" style="margin-bottom: 0em;">
					Abilene Christian University Press </p>
<p class="copy" id="pz4-18">
					ACU Box 29138, Abilene, Texas 79699 </p>
<p class="copy" id="pz4-19">
					1-877-816-4455 | <a href="http://www.acupressbooks.com" id="AvO" target="_blank">www.acupressbooks.com</a> </p>
<p class="copy" id="pz4-20" style="text-align: center; margin-bottom: 0em;">
					18   19   20   21   22   23   /   7   6   5   4   3   2   1 </p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// copyrightpage.vue?4d786f6e